import { render } from "./CampaignCreate.vue?vue&type=template&id=87ed13fa&scoped=true"
import script from "./CampaignCreate.vue?vue&type=script&lang=js"
export * from "./CampaignCreate.vue?vue&type=script&lang=js"

import "./CampaignCreate.vue?vue&type=style&index=0&id=87ed13fa&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ed13fa"]])

export default __exports__